module.exports = __webpack_public_path__ + "static/umber_hulk-8cc3036e1dd54ad5ac867d5c189d2997.jpg";